import { PUBLISH_CONTENT_TYPES } from 'helpers/publishContentTypes';
import {
  runBannerPublishJob,
  runTemplatePublishJob,
  runPagesPublishJob,
  runCategoriesPublishJob,
  runWidgetsPublishJob,
  runSeoPublishJob,
  runInformationPolicyPublishJob,
  runAdminSettingsPublishJob,
  runConfigSettingsPublishJob,
  runShiftPublishJob,
  runTransactionPublishJob,
  runShiftApplicationPublishJob,
  runTimesheetPublishJob,
  runStaffDocumentsPublishJob,
} from 'helpers/formPublishJobs';

export const runPublishJob = ({ job, files, accessToken, onProgress, signal }) => {
  switch (job.contentType) {
    case PUBLISH_CONTENT_TYPES.BANNER:
      return runBannerPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.TEMPLATE:
      return runTemplatePublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.PAGES:
      return runPagesPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.CATEGORIES:
      return runCategoriesPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.WIDGETS:
      return runWidgetsPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.SEO:
      return runSeoPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.INFORMATION_POLICY:
      return runInformationPolicyPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.ADMIN_SETTINGS:
      return runAdminSettingsPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.CONFIG_SETTINGS:
      return runConfigSettingsPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.SHIFT:
      return runShiftPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.TRANSACTION:
      return runTransactionPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.SHIFT_APPLICATION:
      return runShiftApplicationPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.TIMESHEET:
      return runTimesheetPublishJob({
        job,
        accessToken,
        onProgress,
        signal,
      });
    case PUBLISH_CONTENT_TYPES.STAFF_DOCUMENTS:
      return runStaffDocumentsPublishJob({
        job,
        files,
        accessToken,
        onProgress,
        signal,
      });
    default:
      throw new Error('Unsupported publish job type.');
  }
};
